
export default class DxfPolyline {
  constructor (vertices) {
    this.vertices = vertices;
  }

  clone () {
    return new DxfPolyline(this.vertices.slice());
  }

  containsGroup (group) {
    for (let i = 0, n = group.children.length; i < n; i++) {
      let other = group.children[i];
      if (!this.containsPolyline(other)) {
        return false;
      }
    }
    return true;
  }

  containsPolyline (polyline) {
    for (let i = 0, n = polyline.vertices.length; i < n; i++) {
      let p = polyline.vertices[i];
      if (!this.containsPoint(p)) {
        return false;
      }
    }
    return true;
  }

  containsPoint (point) {
    let result = false;
    let n = this.vertices.length;
    for (let i = 0, j = n - 1; i < n; j = i++) {
      let v0 = this.vertices[i];
      let v1 = this.vertices[j];
      if (
        ((v0[1] > point[1]) !== (v1[1] > point[1])) &&
        (point[0] < (v1[0] - v0[0]) * (point[1] - v0[1]) / (v1[1] - v0[1]) + v0[0])
      ) {
        result = !result;
      }
    }
    return result;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/dxf/DxfPolyline.js